export const useStyles = theme => ({
    loginFieldsContainer: {
        marginTop: 4,
        paddingLeft: 55,
    },
    fieldsContainer: {
        marginBottom: '60px',
    },
    fontContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    fontField: {
        marginTop: '13px',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    previousButton: {
        marginRight: '10px',
        boxShadow: 'none !important',
        border: '1px solid grey',
    },
    nextButton: {
        boxShadow: 'none !important',
    },
    colorButton: {
        position: 'absolute',
        left: 150,
        top: 260,
        zIndex: '2',
        backgroundColor: '#009F3C',
        color: 'white'
    },
    colorBox: {
        width: '30px',
        height: '30px',
        marginRight: '14px',
        marginTop: '14px',
        border: '1px solid #ddd',
        cursor: 'pointer',
    },
    colorContainer: {
        display: 'flex',
        borderBottom: '1px solid black',
        paddingBottom: '5px',
        cursor: 'pointer',
        position: 'relative',
    },
    colorPicker: {
        marginTop: '10px',
        position: 'absolute',
        zIndex: '1',
        height: 300,
    },
    colorPickerButton: {
        backgroundColor: '#009F3C',
        color: 'white',
        position: 'absolute',
        left: 135,
        top: 262,
        zIndex: '2',
        width: 80,
        '&:hover': {
            backgroundColor: '#fff',
            color: '#009F3C',
        }
    },
    colorPickerContainer: {
        position: 'relative',
    },
    colorLabel: {
        fontSize: '14px',
        top: '-5px',
        fontWeight: 'bold',
    },
    colorInformation: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        marginRight: '20px',
    },
    disableToggle: {
        pointerEvents: 'none',
        opacity: 0.65,
    },
    tabsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0px 6px',
        marginBottom: '45px',
    },
    tabHeader: {
        fontSize: '14px',
        cursor: 'pointer',
        '&:hover': {
          color: '#009f3c',
        },
    },
    tabHeaderSelected: {
        fontSize: '14px',
        cursor: 'pointer',
        color: '#009f3c',
        fontWeight: 'bold',
        borderBottom: '1px solid #009f3c',
        paddingBottom: '2px',
    },
    opacContainer: {
        marginTop: '10px',
        marginLeft: '50px',
        display: 'flex'
    },
    opacIcon: {
        position: 'relative',
        color: '#009f3c',
        fontSize: '18px',
        fontWeight: 'normal',
        marginRight: '2px',
    },
    opacLabel: {
        fontStyle: 'italic',
        fontSize: '14px',
        marginRight: '10px',
    },
});  